module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "light": ""
    }
  }, [(_vm.isAuthenticated()) ? _c('v-navigation-drawer', {
    attrs: {
      "fixed": "",
      "left": "",
      "temporary": "",
      "app": ""
    },
    model: {
      value: (_vm.showMenu),
      callback: function($$v) {
        _vm.showMenu = $$v
      },
      expression: "showMenu"
    }
  }, [_c('v-list', [_c('v-list-tile', {
    attrs: {
      "to": "/"
    }
  }, [_c('v-icon', {
    staticClass: "ma-3"
  }, [_vm._v("commute")]), _vm._v(" "), _c('v-list-tile-title', {
    staticClass: "title"
  }, [_vm._v("moje dostave")])], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "to": "/profile"
    }
  }, [_c('v-icon', {
    staticClass: "ma-3"
  }, [_vm._v("person")]), _vm._v(" "), _c('v-list-tile-title', {
    staticClass: "title"
  }, [_vm._v("profil")])], 1), _vm._v(" "), (_vm.user.isCourier) ? _c('v-list-tile', {
    attrs: {
      "to": "/balance"
    }
  }, [_c('v-icon', {
    staticClass: "ma-3"
  }, [_vm._v("euro_symbol")]), _vm._v(" "), _c('v-list-tile-title', {
    staticClass: "title"
  }, [_vm._v("stanje računa")])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "to": "/events"
    }
  }, [_c('v-icon', {
    staticClass: "ma-3"
  }, [_vm._v("timeline")]), _vm._v(" "), _c('v-list-tile-title', {
    staticClass: "title"
  }, [_vm._v("dešavanja")])], 1), _vm._v(" "), (_vm.user.isAdmin) ? _c('v-list-tile', {
    attrs: {
      "to": "/users"
    }
  }, [_c('v-icon', {
    staticClass: "ma-3"
  }, [_vm._v("people")]), _vm._v(" "), _c('v-list-tile-title', {
    staticClass: "title"
  }, [_vm._v("korisnici")])], 1) : _vm._e(), _vm._v(" "), (_vm.user.isProxy) ? _c('v-list-tile', {
    attrs: {
      "to": "/couriers"
    }
  }, [_c('v-icon', {
    staticClass: "ma-3"
  }, [_vm._v("people")]), _vm._v(" "), _c('v-list-tile-title', {
    staticClass: "title"
  }, [_vm._v("kuriri")])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "to": "/mobile-application"
    }
  }, [_c('v-icon', {
    staticClass: "ma-3"
  }, [_vm._v("android")]), _vm._v(" "), _c('v-list-tile-title', {
    staticClass: "title"
  }, [_vm._v("android aplikacija")])], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": _vm.logout
    }
  }, [_c('v-icon', {
    staticClass: "ma-3"
  }, [_vm._v("input")]), _vm._v(" "), _c('v-list-tile-title', {
    staticClass: "title"
  }, [_vm._v("odjava")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isAuthenticated()) ? _c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "dark": "",
      "fixed": "",
      "app": "",
      "prominent": ""
    }
  }, [_c('v-btn', {
    staticStyle: {
      "width": "60px",
      "height": "60px"
    },
    attrs: {
      "icon": "",
      "light": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showMenu = !_vm.showMenu
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "https://lanser.rs/img/icons/lanser-32x32.png"
    }
  }), _c('img')]), _vm._v(" "), _c('v-toolbar-title', {
    staticClass: "clickable headline",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.home()
      }
    }
  }, [_vm._v("lanser")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (!_vm.$router.currentRoute.path.includes('/events')) ? _c('v-btn', {
    staticClass: "hidden-sm-and-down",
    attrs: {
      "icon": "",
      "large": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleMessages()
      }
    }
  }, [_c('v-badge', {
    attrs: {
      "value": _vm.unreadMessages != 0,
      "overlap": "",
      "color": "secondary"
    }
  }, [_c('span', {
    attrs: {
      "slot": "badge",
      "secondary": ""
    },
    slot: "badge"
  }, [_vm._v(_vm._s(_vm.unreadMessages))]), _vm._v(" "), _c('v-icon', [_vm._v("storage")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "subheading"
  }, [_vm._v(_vm._s(_vm.userFormatted))]), _vm._v(" "), _c('span', {
    staticClass: "ml-4"
  }, [(!_vm.connectivityStatus.healthy) ? _c('i', {
    staticClass: "fas fa-exclamation-circle fa-2x",
    attrs: {
      "title": "Nema Interneta"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.connectivityStatus.working && _vm.connectivityStatus.healthy) ? _c('i', {
    staticClass: "fas fa-times-circle fa-spin fa-2x",
    attrs: {
      "title": "Učitavanje..."
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.connectivityStatus.working && _vm.connectivityStatus.healthy) ? _c('i', {
    staticClass: "fas fa-circle fa-2x",
    attrs: {
      "title": "Stabilna veza"
    }
  }) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), _c('v-content', [_c('router-view'), _vm._v(" "), (_vm.isAuthenticated()) ? _c('v-navigation-drawer', {
    staticClass: "zi1 hidden-sm-and-down",
    attrs: {
      "clipped": "",
      "hide-overlay": "",
      "fixed": "",
      "right": ""
    },
    model: {
      value: (_vm.showMessages),
      callback: function($$v) {
        _vm.showMessages = $$v
      },
      expression: "showMessages"
    }
  }, [_c('messages', {
    staticClass: "below-toolbar px-0"
  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.logEntries.length > 0 && _vm.debug) ? [_c('v-btn', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.clearLogs()
      }
    }
  }, [_vm._v("clear logs")]), _vm._v(" "), _vm._l((_vm.logEntries), function(log, i) {
    return _c('v-alert', {
      key: i,
      staticClass: "w100",
      attrs: {
        "type": "info",
        "dismissible": ""
      },
      model: {
        value: (log.visible),
        callback: function($$v) {
          _vm.$set(log, "visible", $$v)
        },
        expression: "log.visible"
      }
    }, [_vm._v("\n      " + _vm._s(log.entry) + "\n    ")])
  })] : _vm._e()], 2)
},staticRenderFns: []}